class Api {

	constructor() {
		this.url = 'https://test.hangyahenrik.hu/api/';
	}

	callApi(endpoint, method, data) {
		return new Promise((resolve, reject) => {
			fetch(this.url + endpoint, {
				method: method,
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			})
			.then(response => {
				if (response.status === 200) {
					return response.json();
				} else {
					reject(`Error: ${response.status}`);
				}
			})
			.then(data => resolve(data))
			.catch(error => reject(error));
		});
	}

}

export default new Api();